import {useEffect} from 'react';

import {useLocalesMgr} from 'coreHooks';

import {useVisibilityContext} from '../contexts/viewportProductContext';

export const useProductVisibilityChange = (ref, productId: string) => {
	const {handleVisibilityChange} = useVisibilityContext(true) || {};
	// when user changes the country, products are fetched again.
	// That's why we need to observe intersection again
	const country = useLocalesMgr().getCurrentLocale().getCountryCode();

	useEffect(() => {
		if (!ref?.current || !productId) {
			return;
		}

		const params = {threshold: 0.90};
		const observer = new IntersectionObserver(([entry]: IntersectionObserverEntry[]) => {
			if (entry.isIntersecting) {
				handleVisibilityChange(productId);
				// stop observing when product get into the viewport
				observer.disconnect();
			}
		}, params);

		observer.observe(ref.current);

		return () => observer.disconnect();
	}, [productId, country]);
};
